import { useNavigate } from 'react-router-dom'
import { EnhancedPaper } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Button, Paper, Stack, Title, Text, Image, Flex, TypographyStylesProvider } from 'summon-ui/mantine'
import { graphqlClient } from '@api/config'
import { useGetSuggestedQuestQuery } from '@generated/generates'

const RecommendedCategory = () => {
  const t = useTranslation()
  const navigate = useNavigate()
  const { data, isLoading } = useGetSuggestedQuestQuery(graphqlClient())
  const recommendedCategory = data?.viewer?.currentLevelInfo.nextCategorySuggested
  if (!recommendedCategory) return null

  return (
    <Stack gap='sm' p={{ xs: 'md', md: '0' }}>
      <Title data-testid='recommended-quest-title-label' fz='md' visibleFrom='sm'>
        {t('Recommended Quests')}
      </Title>
      {isLoading ? (
        <Paper withBorder radius='md' bg='gray.3' className='animate-pulse' />
      ) : (
        <EnhancedPaper withBorder p='md' radius='md' withBg>
          <Flex align='center' justify='space-between' gap='sm'>
            <Image
              data-testid='recommended-quest-avatar-image'
              radius='md'
              w='40%'
              bgsz='cover'
              mih='100%'
              src={recommendedCategory?.imageUrl}
            />
            <Stack gap='md' w='100%'>
              <Stack gap='0'>
                <Title data-testid='recommended-quest-name-label' fz='md' lineClamp={1}>
                  {recommendedCategory?.name}
                </Title>
                <TypographyStylesProvider>
                  <Text
                    data-testid='recommended-quest-description-label'
                    size='xs'
                    className='line-clamp-3'
                    dangerouslySetInnerHTML={{ __html: recommendedCategory?.description || '' }}
                  />
                </TypographyStylesProvider>
              </Stack>

              <Button
                data-testid='recommended-quest-view-button'
                fullWidth
                onClick={() => navigate(`/quests/${recommendedCategory?.id}`)}
              >
                {t('View Quests')}
              </Button>
            </Stack>
          </Flex>
        </EnhancedPaper>
      )}
    </Stack>
  )
}

export default RecommendedCategory
